import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from './Icon'
import map from 'lodash/map'

import './style.css.scss'

const IconsRenderer = (props) => {

  const iconTemplate = (iconData, key) => {
    return (
      <div className="paragraph-icon-container" key={key}>
        <Icon
          isImage={iconData.is_image}
          url={iconData.icon_url}
          themeColorHex={props.themeColorHex} />
        <span className="paragraph-text">
          <div className="paragraph-text-title">{iconData.title}</div>
          <div className="paragraph-text-description">{iconData.description}</div>
        </span>
      </div>
    )
  }

  return (
    map(props.iconsData, (value, key) => {
      return iconTemplate(value, key)
    })
  )
}

IconsRenderer.propTypes = {
  iconsData: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default IconsRenderer